import { createUseStyles } from 'react-jss';

import { color, radius, spacing } from '../variables';

export const useToggleStyles = createUseStyles({
    wrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        height: 44,
        padding: `0 ${spacing['04']}`,
        alignItems: 'center',
        gap: 2,
        alignSelf: 'stretch',
        borderRadius: radius.overall,
        border: `1px solid ${color.border.opaque}`,
        '& .ant-switch': {
            background: 'rgba(0, 0, 0, 0.45)',
            '&.ant-switch-checked': {
                background: color.background.inversePrimary,
            },
        },
    },
});
